import * as signalR from '@microsoft/signalr';
import { storage } from 'BASE/common/util/util.storage';
import * as apiProxy from 'BASE/common/util/util.apiProxy';

class SignalrClientAdapter {
    constructor(connection, clientName) {
        this.connection = connection;
        this.handlers = [];
        this.permanentHandlers = [];

        this.connection.on(clientName, (input) => {
            for (let i = 0; i < this.handlers.length; i++) {
                this.handlers[i](input);
            }
            for (let i = 0; i < this.permanentHandlers.length; i++) {
                this.permanentHandlers[i](input);
            }
        });
    }

    addHandler(handler) {
        this.handlers.push(handler);
        return handler;
    }

    removeHandler(handler) {
        for (let i = 0; i < this.handlers.length; i++) {
            if (this.handlers[i] === handler) {
                this.handlers.splice(i, 1);
                break;
            }
        }
    }

    clearHandler() {
        this.handlers = [];
    }

    addPermanentHandler(handler) {
        this.permanentHandlers.push(handler);
        return handler;
    }

    removePermanentHandler(handler) {
        for (let i = 0; i < this.permanentHandlers.length; i++) {
            if (this.permanentHandlers[i] === handler) {
                this.permanentHandlers.splice(i, 1);
                break;
            }
        }
    }
}

class BetSignalrServerAdapter {
    constructor(connection) {
        this.connection = connection;
    }

    join(gameId, quitGameId) {
        return this.connection.invoke("Join", gameId, quitGameId);
    }

    multiJoin(gameIdList, quitGameIdList) {
        return this.connection.invoke("MultiJoin", gameIdList, quitGameIdList);
    }

    joinComboBet(isjoin) {
        return this.connection.invoke("JoinComboBet", isjoin);
    }

    JoinLeaderboard(isjoin) {
        return this.connection.invoke("JoinLeaderboard", isjoin);
    }

    JoinDrawTrend(isjoin) {
        return this.connection.invoke("JoinDrawTrend", isjoin);
    }
}

class BetSignalrClientAdapter {
    constructor(connection) {
        let _this = this;
        this.connection = connection;
        this.adapters = new Array(
            this.receiveWinningNumberAdapter = new SignalrClientAdapter(this.connection, "ReceiveWinningNumber"),
            this.updateIssueStatisticAdapter = new SignalrClientAdapter(this.connection, "UpdateStatistic"),
            this.lotteryAwardedAdapter = new SignalrClientAdapter(this.connection, "LotteryAwarded"),
            this.updateComboBetGameItem = new SignalrClientAdapter(this.connection, "updateComboBetGameItem"),
            this.updateLeaderBoard = new SignalrClientAdapter(this.connection, "updateLeaderBoard"),
            this.betNumberOddsUpdateAdapter = new SignalrClientAdapter(this.connection, "BetNumberOddsUpdate"),
        );
    }
}

class BetSignalrReconnectionHandler{
    constructor(connectionChangedHandlers) {
        this.handlers = [];
        connectionChangedHandlers.push((oldState, newState) => this.handle(oldState, newState, this.handlers));
    }

    addHandler(handler) {
        this.handlers.push(handler);
    }

    clearHandler() {
        this.handlers = [];
    }

    handle(oldState, newState, handlers) {
        if (!newState) {
            return;
        }

        for (let handler of handlers) {
            handler(oldState, newState);
        }
    }
}

class ChatSignalrServerAdapter {
    constructor(connection) {
        this.connection = connection;
    }

    getInitialData() {
        return this.connection.invoke("GetInitialData");
    }

    getInitialDataAnonymity() {
        return this.connection.invoke("GetInitialDataAnonymity");
    }

    addMessage(input) {
        return this.connection.invoke("AddMessage", input);
    }

    addMessageMulticast(input) {
        return this.connection.invoke("AddMessageMulticast", input);
    }

    addMessageAnonymity(input) {
        return this.connection.invoke("AddMessageAnonymity", input);
    }

    getHistoryMessage(input) {
        return this.connection.invoke("GetHistoryMessage", input);
    }

    getHistoryMessageCount(input) {
        return this.connection.invoke("GetHistoryMessageCount", input);
    }

    syncWhenReconnected() {
        return this.connection.invoke("SyncWhenReconnected");
    }

    updateRoomActiveTime(input) {
        return this.connection.invoke("UpdateRoomActiveTime", input);
    }

    setHistoryMessageClearTime(input) {
        return this.connection.invoke("SetHistoryMessageClearTime", input);
    }

    addCustomerServiceWaiting(input) {
        return this.connection.invoke("AddCustomerServiceWaiting", input);
    }

    updateConnectionActiveTime() {
        return this.connection.invoke("UpdateConnectionActiveTime");
    }

    addGroupRoom(input) {
        return this.connection.invoke("AddGroupRoom", input);
    }

    removeGroupRoom(input) {
        return this.connection.invoke("RemoveGroupRoom", input);
    }

    setGroupRoomName(input) {
        return this.connection.invoke("setGroupRoomName", input);
    }

    addGroupRoomMember(input) {
        return this.connection.invoke("AddGroupRoomMember", input);
    }

    removeGroupRoomMember(input) {
        return this.connection.invoke("RemoveGroupRoomMember", input);
    }

    getGroupRoomMember(input) {
        return this.connection.invoke("GetGroupRoomMember", input);
    }

    updateGroupRoomReadOnly(input) {
        return this.connection.invoke("UpdateGroupRoomReadOnly", input);
    }

    updateGroupRoomMemberReadOnly(input) {
        return this.connection.invoke("UpdateGroupRoomMemberReadOnly", input);
    }

    setGroupRoomAnnouncement(input) {
        return this.connection.invoke("setGroupRoomAnnouncement", input);
    }

    setGroupRoomMemberRole(input) {
        return this.connection.invoke("SetGroupRoomMemberRole", input);
    }

    setCustomerServiceRating(input) {
        return this.connection.invoke("setCustomerServiceRating", input);
    }

    addGroupRoomAnnouncementByJSON(input) {
        return this.connection.invoke("AddGroupRoomAnnouncementByJSON", input);
    }

    removeGroupRoomAnnouncementByJSON(input) {
        return this.connection.invoke("RemoveGroupRoomAnnouncementByJSON", input);
    }

    enterSiteGroupRoom(input) {
        return this.connection.invoke("EnterSiteGroupRoom", input);
    }

    reEnterSiteGroupRoom(input) {
        return this.connection.invoke("ReEnterSiteGroupRoom", input);
    }

    leaveSiteGroupRoom(input) {
        return this.connection.invoke("LeaveSiteGroupRoom", input);
    }

    getSiteGroupRooms() {
        return this.connection.invoke("GetSiteGroupRooms");
    }
    
    removeSiteGroupMessage(input) {
        return this.connection.invoke("RemoveSiteGroupMessage", input);
    }

    getSiteGroupMessageUserInfo(input) {
        return this.connection.invoke("GetSiteGroupMessageUserInfo", input);
    }

    updateSiteGroupMemberReadOnly(input) {
        return this.connection.invoke("UpdateSiteGroupMemberReadOnly", input);
    }

    clearSiteGroupMessage(input) {
        return this.connection.invoke("ClearSiteGroupMessage", input);
    }

    setSiteGroupPinMessage(input) {
        return this.connection.invoke("SetSiteGroupPinMessage", input);
    }

    siteGroupTutorSearchMember(input) {
        return this.connection.invoke("SiteGroupTutorSearchMember", input);
    }

    removeSiteGroupTutorRecentRoom(input) {
        return this.connection.invoke("RemoveSiteGroupTutorRecentRoom", input);
    }

    getSiteGroupRoomMemberList(input) {
        return this.connection.invoke("GetSiteGroupRoomMemberList", input);
    }
}

class ChatSignalrClientAdapter {
    constructor(connection) {
        let _this = this;
        this.connection = connection;
        this.adapters = new Array(
            this.receiveMessageAdapter = new SignalrClientAdapter(this.connection, "ReceiveMessage"),
            this.removeMessageAdapter = new SignalrClientAdapter(this.connection, "RemoveMessage"),
            this.changeOnlineStateAdapter = new SignalrClientAdapter(this.connection, "ChangeOnlineState"),
            this.clearHistoryMessageAdapter = new SignalrClientAdapter(this.connection, "ClearHistoryMessage"),
            this.startCustomerServiceServingAdapter = new SignalrClientAdapter(this.connection, "StartCustomerServiceServing"),
            this.finishCustomerServiceServingAdapter = new SignalrClientAdapter(this.connection, "FinishCustomerServiceServing"),
            this.addRoom = new SignalrClientAdapter(this.connection, "AddRoom"),
            this.removeRoom = new SignalrClientAdapter(this.connection, "RemoveRoom"),
            this.changeRoomName = new SignalrClientAdapter(this.connection, "ChangeRoomName"),
            this.addRoomMember = new SignalrClientAdapter(this.connection, "AddRoomMember"),
            this.removeRoomMember = new SignalrClientAdapter(this.connection, "RemoveRoomMember"),
            this.changeRoomAnnouncement = new SignalrClientAdapter(this.connection, "ChangeRoomAnnouncement"),
            this.updateRoomReadOnly = new SignalrClientAdapter(this.connection, "UpdateRoomReadOnly"),
            this.updateRoomMemberReadOnly = new SignalrClientAdapter(this.connection, "UpdateRoomMemberReadOnly"),
            this.setRoomMemberRole = new SignalrClientAdapter(this.connection, "SetRoomMemberRole"),
            this.enterSiteGroupRoom = new SignalrClientAdapter(this.connection, "EnterSiteGroupRoom"),
            this.chatRoomBetAwardNotify = new SignalrClientAdapter(this.connection, "ChatRoomBetAwardNotify"),
            this.updatePinMessage = new SignalrClientAdapter(this.connection, "UpdatePinMessage"),
        );
    }

    clearAllHandlers() {
        for (let i = 0; i < this.adapters.length; i++) {
            this.adapters[i].clearHandler();
        }
    }
}

class InstantMessageClientAdapter {
    constructor(connection) {
        let _this = this;
        this.connection = connection;
        this.adapters = new Array(
            this.receiveMessage = new SignalrClientAdapter(this.connection, "ReceiveInstantMessage"),
        );
        
    }

    clearAllHandlers() {
        for (let i = 0; i < this.adapters.length; i++) {
            this.adapters[i].clearHandler();
        }
    }
}

class ToastNotifyClientAdapter {
    constructor(connection) {
        this.connection = connection;
        this.toastNotification = new SignalrClientAdapter(this.connection, "ToastNotification");
    }
}

class BetAwardNotifyClientAdapter {
    constructor(connection) {
        let _this = this;
        this.connection = connection;
        this.betAwardNotify = new SignalrClientAdapter(this.connection, "BetAwardNotify");
    }
}

class CancelDepositNotifyClientAdapter {
    constructor(connection) {
        let _this = this;
        this.connection = connection;
        this.CancelDepositNotify = new SignalrClientAdapter(this.connection, "CancelDepositNotify");
    }
}

class UserInfoPrivilegesClientAdapter {
    constructor(connection) {
        let _this = this;
        this.connection = connection;
        this.userInfoPrivileges = new SignalrClientAdapter(this.connection, "UserInfoPrivileges");
    }
}

class WechatSignalrServerAdapter {
    constructor(connection) {
        this.connection = connection;
    }

    getWechatLoginInitial() {
        return this.connection.invoke("GetWechatLoginInitial");
    }
}

class WechatSignalrClientAdapter {
    constructor(connection) {
        let _this = this;
        this.connection = connection;
        this.qrCodeLogin = new SignalrClientAdapter(this.connection, "QrCodeLogin");
    }
}

class WebSiteURLConfigClientAdapter {
    constructor(connection) {
        this.connection = connection;
        this.WebSiteURLConfig = new SignalrClientAdapter(this.connection, "WebSiteURLConfig");
    }
}

class URLListAdapter {
    constructor(connection) {
        this.connection = connection;
        this.URLList = new SignalrClientAdapter(this.connection, "WebSiteURLList");
    }
}

class BetCollectionClientAdapter {
    constructor(connection) {
        this.connection = connection;
        this.update = new SignalrClientAdapter(this.connection, "UpdateBetCollection");
    }
}

class BindElectronicPurseNotifyClientAdapter {
    constructor(connection) {
        let _this = this;
        this.connection = connection;
        this.BindElectronicPurseNotify = new SignalrClientAdapter(this.connection, "BindElectronicPurse");
    }
}

class SignalrAdapter {
    constructor() {
        this.initCallbacks = [];
        this.heartbeatIntervalId;
        this.transport = signalR.HttpTransportType.WebSockets;
    }

    async start(payload) {
        let tryStart = true;
        while (tryStart) {
            try {
                this.log(`signalr start, transport = ${this.getHttpTransportTypeName(this.transport)}`);

                this.connection = new signalR.HubConnectionBuilder()
                    .withUrl(this.getConnectionUrl(payload), {
                        transport: this.transport,
                        skipNegotiation: this.transport === signalR.HttpTransportType.WebSockets,
                        accessTokenFactory: () => {
                            let accessToken = storage.local.get(storage.keys.ACCESS_TOKEN);
                            this.isLoginValidated = accessToken ? true : false;
                            return accessToken;
                        },
                    })
                    .configureLogging(ENVIRONMENT.PRODUCTION ? signalR.LogLevel.Error : signalR.LogLevel.Trace)
                    .build();

                await this.connection.start();
                tryStart = false;
            } catch (err) {
                console.error('signalr start failed', err);
                this.log('signalr start failed');
                this.transport =
                    this.transport === signalR.HttpTransportType.WebSockets
                        ? signalR.HttpTransportType.LongPolling
                        : signalR.HttpTransportType.WebSockets;
                this.log(
                    `signalr start failed, try to change transport to ${this.getHttpTransportTypeName(this.transport)}`
                );
                await new Promise(resolve => setTimeout(resolve, 1000))
            }
        }
    }

    async reStartStop() {
        if (!this.isReStartStopped) {
            this.log('signalr reStartStop, stop connection');
            this.isReStartStopped = true;
            try {
                await this.connection.stop();
            } catch (err) {
                console.error('signalr reStartStop failed', err);
                // 這裡應該要設回false，但是stop在未連線成功前重複呼叫兩次以上可能會一直錯誤，這個try catch也是避免這個情況，所以就不設回false
                // this.isReStartStopped = false;
            }
        }
    }

    async reStart() {
        if (this.isStopped) {
            return;
        }

        try {
            this.log(`signalr reStart, current connection state: ${this.connection.state}`);
            await this.reStartStop();
            await this.connection.start();
            this.setConnectionState(true);
        } catch (err) {
            console.error('signalr reStart failed', err);
            this.setConnectionState(false);
            let retryTime = this.getRandomRetryTime(0.5, 1.5);
            this.log(`signalr retry start after ${retryTime}ms`);
            setTimeout(() => this.reStart(), retryTime);
        }
    }

    async stop() {
        this.isStopped = true;
        clearInterval(this.heartbeatIntervalId);
        await this.connection.stop();
        this.setConnectionState(false);
    }

    async init(payload) {
        payload = payload ? payload : {};
        this.isLoginValidated = false;

        await this.start(payload);

        this.isInitialized = false;
        this.isConnected = false;
        this.isStopped = false;
        this.isReStartStopped = false;
        this.connectionChangedHandlers = [];

        this.betServer = new BetSignalrServerAdapter(this.connection);
        this.betClient = new BetSignalrClientAdapter(this.connection);
        this.chatServer = new ChatSignalrServerAdapter(this.connection);
        this.chatClient = new ChatSignalrClientAdapter(this.connection);
        this.instantMessageClient = new InstantMessageClientAdapter(this.connection);
        this.toastNotifyClient = new ToastNotifyClientAdapter(this.connection);
        this.betAwardNotifyClient = new BetAwardNotifyClientAdapter(this.connection);
        this.CancelDepositNotifyClient = new CancelDepositNotifyClientAdapter(this.connection);
        this.userInfoPrivilegesClient = new UserInfoPrivilegesClientAdapter(this.connection);
        this.wechatServer = new WechatSignalrServerAdapter(this.connection);
        this.wechatClient = new WechatSignalrClientAdapter(this.connection);
        this.WebSiteURLConfig = new WebSiteURLConfigClientAdapter(this.connection);
        this.URLList = new URLListAdapter(this.connection);
        this.BetCollection = new BetCollectionClientAdapter(this.connection);
        this.BindElectronicPurseNotifyClient = new BindElectronicPurseNotifyClientAdapter(this.connection);

        // 斷線後重新連上時處理
        this.betReconnectHandler = new BetSignalrReconnectionHandler(this.connectionChangedHandlers);

        this.connection.onclose(async () => {
            this.log(`signalr get onclose, current connected is ${this.isConnected}`);
            if (this.isConnected) {
                this.setConnectionState(false);
                await this.reStart();
            }
        });

        // 連線成功設定第一次連上線的工作和狀態
        this.startHeartbeat();
        this.isInitialized = true;
        this.setConnectionState(true);
    }

    // NOTICE: 這個目前只用在匿名聊天室沒有問題，但是用在登入後的頁面，可能會因為重新init造成很多事件重覆或是沒有註冊
    async reInit(payload) {
        // NOTICE: JhihPing, 如果之後首頁出現要使用payload的情況, 就要寫一個功能先把首頁的payload存起來, reInit如果是undefined就使用
        await this.stop();
        this.init(payload);

        // register client callback on init
        for (let i = 0; i < this.initCallbacks.length; i++) {
            this.initCallbacks[i]();
        }
    }

    getConnectionUrl(payload) {
        let connectionUrl = apiProxy.urlCombine('/Hub');
        let urlParameters = [];
        urlParameters.push({ name: 'loginId', value: payload.loginId });
        urlParameters.push({ name: 'roomId', value: payload.roomId });
        if (urlParameters.length > 0) {
            connectionUrl += '?';
            urlParameters.forEach((item) => {
                if (item.value) {
                    connectionUrl += item.name + '=' + item.value + '&';
                }
            });
            connectionUrl = connectionUrl.substring(0, connectionUrl.length - 1);
        }
        return connectionUrl;
    }

    startHeartbeat() {
        this.heartbeatIntervalId = setInterval(async () => {
            try {
                if (this.isConnected) {
                    await this.chatServer.updateConnectionActiveTime();
                }
            } catch (err) {
                console.error('startHeartbeat failed', err);
            }
        }, 300000);
    }

    setConnectionState(isConnected) {
        if (this.isConnected !== isConnected) {
            if (this.isConnected) {
                this.log('signalr connection changed: connected => disconnected');
            } else {
                this.log(
                    `signalr connection changed: disconnected => connected (${this.connection.connectionId})`
                );
                this.isReStartStopped = false;
            }

            for (let i = 0; i < this.connectionChangedHandlers.length; i++) {
                this.connectionChangedHandlers[i](this.isConnected, isConnected);
            }

            this.isConnected = isConnected;
        }
    }

    onConnectionStateChanged(handler) {
        this.connectionChangedHandlers.push(handler);
    }

    addWorkOnConnected(handler) {
        if (this.isConnected) {
            handler();
        } else {
            setTimeout(() => this.addWorkOnConnected(handler), 1000);
        }
    }

    // registerCallbackAfterInit(callback) {
    //     callback();
    //     this.initCallbacks.push(callback);
    // }

    getRandomRetryTime(min, max) {
        return (Math.random() * (max - min) + min).toFixed(3) * 1000;
    }

    getHttpTransportTypeName(type) {
        switch (type) {
            case signalR.HttpTransportType.WebSockets:
                return 'WebSockets';
            case signalR.HttpTransportType.ServerSentEvents:
                return 'ServerSentEvents';
            case signalR.HttpTransportType.LongPolling:
                return 'LongPolling';
            default:
                return 'Unknown';
        }
    }

    getLoginValidatedStatus() {
        return this.isLoginValidated;
    }

    log(message) {
        console.log(`[${new Date().toISOString()}] ${message}`);
    }
}

export default new SignalrAdapter();
